import {useState} from 'react';
import {Button, Input, Row, Col, message} from 'antd';
import {changeUserPassword} from "../../api/Api";
import {handleNoSession} from "../../util/errorUtils";

export const ChangePassword = ({onApiFail}) => {
    const [password, setPassword] = useState(undefined);
    const [newPassword, setNewPassword] = useState(undefined);
    const [messageApi, contextHolder] = message.useMessage();

    const clearForm = () => {
        setPassword(undefined);
        setNewPassword(undefined);
    }

    const onPasswordChange = (e) => {
        setPassword(e.target.value);
    }

    const onNewPasswordChange = (e) => {
        setNewPassword(e.target.value);
    }

    const onSave = () => {
        changeUserPassword(password, newPassword).then(r => {
            clearForm();
            messageApi.open({
                type: 'success',
                content: 'Password Changed',
            })
        }).catch(e => {
            handleNoSession(e, onApiFail);
            clearForm();
            messageApi.open({
                type: 'error',
                content: 'Failed to change password',
            })
        })
    }

    const divStyle={
        textAlign: 'left'
    }

    const rowStyle={
        marginTop: '5px',
        marginBottom: '5px',
    }

    return <div style={divStyle}>
        {contextHolder}
        <Row style={rowStyle}>
            <Col span={3}><b>Old Password:</b></Col>
            <Col>
                <Input.Password onChange={onPasswordChange} />
            </Col>
        </Row>
        <Row style={rowStyle}>
            <Col span={3}><b>New Password:</b></Col>
            <Col>
                <Input.Password onChange={onNewPasswordChange} />
            </Col>
        </Row>
        <Row style={rowStyle}>
            <Button onClick={onSave}>Save</Button>
        </Row>
    </div>
}